import React from 'react';
import { Form } from 'antd';
import CustomerTextInput from '../../../inputs/customerTextInput/CustomerTextInput';
import DefaultButton from '../../../components/buttons/defaultButton/DefaultButton';
import useTranslation from '../../../../hooks/translation/useTranslation';
import CustomerSelectInput from '../../../inputs/customerSelectInput/CustomerSelectInput';

function PhysicalRegistrationFirstStepForm({
  form, handleSubmit, formValues, errors,
}) {
  const { trans, currentLanguage, configInfo } = useTranslation();
  const isGeorgian = configInfo?.countryCode === 'GE';
  return (
    <Form layout="vertical" form={form} onFinish={handleSubmit} className="grid lg:grid-cols-2 gap-4">
      <CustomerTextInput
        rules={[{
          required: true,
          message: trans('input_necessary'),
        }]}
        name="first_name"
        label={trans('first_name')}
        required
        errorMessage={errors?.first_name}
      />
      <CustomerTextInput
        rules={[{
          required: true,
          message: trans('input_necessary'),
        }]}
        name="id_number"
        label={trans(isGeorgian ? 'id_number' : 'passport_number')}
        required
        errorMessage={errors?.personal_number || errors?.passport_number}
      />
      <CustomerTextInput
        rules={[{
          required: true,
          message: trans('input_necessary'),
        }]}
        className="row-start-2 lg:row-start-auto"
        name="last_name"
        label={trans('last_name')}
        required
        errorMessage={errors?.last_name}
      />
      <CustomerSelectInput
        rules={[{
          required: true,
          message: trans('input_necessary'),
        }]}
        options={formValues?.countries?.map((country) => ({
          value: country.id,
          label: country?.[`name_${currentLanguage}`] || country.name_ka,
        }))}
        className="flex-1 white-background"
        name="citizenship"
        label={trans('citizenship')}
        required
        errorMessage={errors?.citizenship}
        search={false}
      />
      <CustomerSelectInput
        rules={[{
          required: true,
          message: trans('input_necessary'),
        }]}
        options={formValues?.genders?.map((gender) => ({
          value: gender.value,
          label: trans(gender?.label),
        }))}
        className="basis-1/2 white-background"
        name="gender"
        label={trans('gender')}
        errorMessage={errors?.gender}
        search={false}
      />
      <DefaultButton
        type="submit"
        className="basis-1/2 text-base leading-[22px] h-[60px] mt-auto mb-6"
      >
        {trans('next')}
      </DefaultButton>
    </Form>
  );
}

export default PhysicalRegistrationFirstStepForm;
